import React from "react";
import classNames from "classnames";
import { CardHeaderProps } from "./PropsType";

export default function CardHeader(props: CardHeaderProps) {
  const {
    action,
    avatar,
    className,
    prefixCls = "bm-CardHeader",
    subTitle,
    title,
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className);
  return (
    <div className={styleClass} {...other}>
      {avatar ? <div className={`${prefixCls}-avatar`}>{avatar}</div> : null}
      <div className={`${prefixCls}-content`}>
        <div className={`${prefixCls}-title`}>{title}</div>
        <div className={`${prefixCls}-subtitle`}>{subTitle}</div>
      </div>
      <div className={`${prefixCls}-action`}>{action}</div>
    </div>
  );
}
